window.lib = window.lib || {};
window.images = window.images || {};
window.ss = window.ss || {};
(function (lib, img, ss, cjs) {

var p; // shortcut to reference prototypes

lib.ssMetadata = [];


(lib.AnMovieClip = function(){
	this.actionFrames = [];
	this.ignorePause = false;
	this.gotoAndPlay = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndPlay.call(this,positionOrLabel);
	}
	this.play = function(){
		cjs.MovieClip.prototype.play.call(this);
	}
	this.gotoAndStop = function(positionOrLabel){
		cjs.MovieClip.prototype.gotoAndStop.call(this,positionOrLabel);
	}
	this.stop = function(){
		cjs.MovieClip.prototype.stop.call(this);
	}
}).prototype = p = new cjs.MovieClip();
// symbols:



(lib.Background_Blue = function() {
	this.initialize(img.MainAssets_Background_Blue);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,977,2052);


(lib.Button_disabled = function() {
	this.initialize(img.MainAssets_Button_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_down = function() {
	this.initialize(img.MainAssets_Button_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.Button_up = function() {
	this.initialize(img.MainAssets_Button_up);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,433,170);


(lib.FeedbackPopup_Left = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Left);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.FeedbackPopup_Middle = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Middle);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,126,75);


(lib.FeedbackPopup_Right = function() {
	this.initialize(img.MainAssets_FeedbackPopup_Right);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,50,75);


(lib.MoveNudge = function() {
	this.initialize(img.MainAssets_MoveNudge);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,267,268);


(lib.OverlayBird01 = function() {
	this.initialize(img.MainAssets_OverlayBird01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1632,2409);


(lib.OverlayNext = function() {
	this.initialize(img.MainAssets_OverlayNext);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1460,2229);


(lib.OverlayPracticeIndicator = function() {
	this.initialize(img.MainAssets_OverlayPracticeIndicator);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1428,2173);


(lib.OverlayTime01 = function() {
	this.initialize(img.MainAssets_OverlayTime01);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1632,2408);


(lib.PopupBG = function() {
	this.initialize(img.MainAssets_PopupBG);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1123,787);


(lib.PopupBG_small = function() {
	this.initialize(img.MainAssets_PopupBG_small);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1124,495);


(lib.PracticeIndicatorBackground = function() {
	this.initialize(img.MainAssets_PracticeIndicatorBackground);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1492,152);


(lib.PrevNextButton = function() {
	this.initialize(img.MainAssets_PrevNextButton);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_disabled = function() {
	this.initialize(img.MainAssets_PrevNextButton_disabled);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.PrevNextButton_down = function() {
	this.initialize(img.MainAssets_PrevNextButton_down);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,76,76);


(lib.ProgressDot = function() {
	this.initialize(img.MainAssets_ProgressDot);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.ProgressDot_Selected = function() {
	this.initialize(img.MainAssets_ProgressDot_Selected);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,31,31);


(lib.StartScreen = function() {
	this.initialize(img.MainAssets_StartScreen);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1431,2858);


(lib.TimeUpBird = function() {
	this.initialize(img.MainAssets_TimeUpBird);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,478,516);


(lib.TopbarHUD = function() {
	this.initialize(img.MainAssets_TopbarHUD);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1334,159);


(lib.TutorialBackgroundNext_1 = function() {
	this.initialize(img.MainAssets_TutorialBackgroundNext_1);
}).prototype = p = new cjs.Bitmap();
p.nominalBounds = new cjs.Rectangle(0,0,1632,2408);// helper functions:

function mc_symbol_clone() {
	var clone = this._cloneProps(new this.constructor(this.mode, this.startPosition, this.loop, this.reversed));
	clone.gotoAndStop(this.currentFrame);
	clone.paused = this.paused;
	clone.framerate = this.framerate;
	return clone;
}

function getMCSymbolPrototype(symbol, nominalBounds, frameBounds) {
	var prototype = cjs.extend(symbol, cjs.MovieClip);
	prototype.clone = mc_symbol_clone;
	prototype.nominalBounds = nominalBounds;
	prototype.frameBounds = frameBounds;
	return prototype;
	}


(lib.DragNudgeSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.MoveNudge();
	this.instance.setTransform(-153.5,-17.95);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.DragNudgeSkin, new cjs.Rectangle(-153.5,-17.9,267,268), null);


(lib.Tween2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot_Selected();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.TutorialLines4 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("Eg2/AQeMBt/AAAMAAAgg7");
	this.shape.setTransform(-43.025,-21.425);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines4, new cjs.Rectangle(-396,-127.8,706,212.8), null);


(lib.TutorialLines3 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("A6WYYMA0tAAAMAAAgwv");
	this.shape.setTransform(0,69);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines3, new cjs.Rectangle(-169.7,-87.9,339.4,313.9), null);


(lib.TutorialLines2 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EhD9g1WMCH7AAAMAAABqu");
	this.shape.setTransform(0,-261.5);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines2, new cjs.Rectangle(-436,-604,872,685.1), null);


(lib.TutorialLines1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EhD8g7zMCH5AAAMAAAB3n");
	this.shape.setTransform(0.025,-250.7875);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialLines1, new cjs.Rectangle(-435.9,-634.6,871.9,767.7), null);


(lib.TutorialButtonHitarea = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#333333").s().p("ApkC3IAAltITJAAIAAFtg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialButtonHitarea, new cjs.Rectangle(-61.2,-18.2,122.5,36.5), null);


(lib.TutorialBackgroundTime = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.OverlayTime01();
	this.instance.setTransform(-829.2,-1208.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundTime, new cjs.Rectangle(-829.2,-1208.1,1632,2408), null);


(lib.TutorialBackgroundScore = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.TutorialBackgroundNext_1();
	this.instance.setTransform(-824.7,-1210.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundScore, new cjs.Rectangle(-824.7,-1210.5,1632,2408), null);


(lib.TutorialBackgroundPractice = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// cutout BITMAPS
	this.instance = new lib.OverlayPracticeIndicator();
	this.instance.setTransform(132.05,128.1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundPractice, new cjs.Rectangle(132.1,128.1,1428.3000000000002,2173), null);


(lib.TutorialBackgroundNext = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EAAAhVTMAAACqn");
	this.shape.setTransform(430.4,174.175);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// cutout BITMAP
	this.instance = new lib.OverlayNext();
	this.instance.setTransform(-730,-1114.05);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundNext, new cjs.Rectangle(-730,-1114,1460.4,2229), null);


(lib.TutorialBackgroundBird = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// line
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("EAhjhV8MAAACr5MhDFAAA");
	this.shape.setTransform(215.7,164.0875);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	// Layer_1
	this.instance = new lib.OverlayBird01();
	this.instance.setTransform(-822.15,-1226.2);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TutorialBackgroundBird, new cjs.Rectangle(-822.1,-1226.2,1632,2409), null);


(lib.ProgressDotTween = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.ProgressDot();
	this.instance.setTransform(-15.5,-15.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-15.5,-15.5,31,31);


(lib.PracticeIndicatorSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// text
	this.textfield = new cjs.Text("xPractice level", "bold 74px 'Roboto'", "#FFFFFF");
	this.textfield.name = "textfield";
	this.textfield.textAlign = "center";
	this.textfield.lineHeight = 89;
	this.textfield.lineWidth = 1193;
	this.textfield.parent = this;
	this.textfield.setTransform(-49.65,-47.65);
ranj.TextOffsetFixer.fix(this.textfield);

	this.timeline.addTween(cjs.Tween.get(this.textfield).wait(1));

	// bg BITMAPS
	this.instance = new lib.PracticeIndicatorBackground();
	this.instance.setTransform(-796.3,-76.05);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.PracticeIndicatorSkin, new cjs.Rectangle(-796.3,-76,1492,152), null);


(lib.GateKeeperOverlayLines = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#FFFFFF").ss(1,1,1).p("Eg9tANIMB7bAAAIAA6P");
	this.shape.setTransform(-0.025,-0.025);

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperOverlayLines, new cjs.Rectangle(-396,-85,792,170), null);


(lib.LevelPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.text = new cjs.Text("[level]", "150px 'Arial'", "#FF0000");
	this.text.textAlign = "center";
	this.text.lineHeight = 162;
	this.text.lineWidth = 610;
	this.text.alpha = 0.80000000;
	this.text.parent = this;
	this.text.setTransform(307.05,2);
ranj.TextOffsetFixer.fix(this.text);

	this.timeline.addTween(cjs.Tween.get(this.text).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.LevelPlaceholder, new cjs.Rectangle(0,0,614.2,268.3), null);


(lib.FeedbackPopupBG_Right = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Right();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Right, new cjs.Rectangle(0,0,50,75), null);


(lib.FeedbackPopupBG_Middle = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Middle();
	this.instance.setTransform(-2,0,1.0482,1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Middle, new cjs.Rectangle(-2,0,132.1,75), null);


(lib.FeedbackPopupBG_Left = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.FeedbackPopup_Left();

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG_Left, new cjs.Rectangle(0,0,50,75), null);


(lib.StartGameButton_Overlay = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {up:0,over:1,down:2,disabled:3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 19;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 19;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 19;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "16px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 19;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.StartGameButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 26;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 26;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 26;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "22px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 26;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-14.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.RevisitTutorialButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Revisit instructions", "16px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 19;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Revisit instructions", "16px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 19;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Revisit instructions", "16px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 19;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Revisit instructions", "16px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 19;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-11.25);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-89.95,-30.9,0.4157,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-89.9,-30.9,180,68);


(lib.NextLocationButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text Up
	this.upLabelTextField = new cjs.Text("Start", "17px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "center";
	this.upLabelTextField.lineHeight = 20;
	this.upLabelTextField.lineWidth = 146;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(0.05,-12.05);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text Over
	this.overLabelTextField = new cjs.Text("Start", "17px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "center";
	this.overLabelTextField.lineHeight = 20;
	this.overLabelTextField.lineWidth = 146;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(0.05,-12.05);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text Down
	this.downLabelTextField = new cjs.Text("Start", "17px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "center";
	this.downLabelTextField.lineHeight = 20;
	this.downLabelTextField.lineWidth = 146;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(0.05,-12.05);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text Disabled
	this.disabledLabelTextField = new cjs.Text("Start", "17px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "center";
	this.disabledLabelTextField.lineHeight = 20;
	this.disabledLabelTextField.lineWidth = 146;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(0.05,-12.05);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.Button_up();
	this.instance.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_1 = new lib.Button_down();
	this.instance_1.setTransform(-86.6,-30.9,0.4,0.3999);

	this.instance_2 = new lib.Button_disabled();
	this.instance_2.setTransform(-86.6,-30.9,0.4,0.3999);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-86.6,-30.9,173.2,68);


(lib.BirdTEMP = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.shape = new cjs.Shape();
	this.shape.graphics.f().s("#0000FF").ss(1,1,1).p("AEpAAQAAB7hXBXQhXBXh7AAQh6AAhXhXQhXhXAAh7QAAh6BXhXQBXhXB6AAQB7AABXBXQBXBXAAB6g");
	this.shape.setTransform(-0.025,-30.125);

	this.shape_1 = new cjs.Shape();
	this.shape_1.graphics.f("#FFFFFF").s().p("AjRDSQhXhXAAh7QAAh6BXhXQBXhXB6AAQB7AABXBXQBXBXAAB6QAAB7hXBXQhXBXh7AAQh6AAhXhXg");
	this.shape_1.setTransform(-0.025,-30.125);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.shape_1},{t:this.shape}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BirdTEMP, new cjs.Rectangle(-30.7,-60.8,61.4,61.4), null);


(lib.Backgroundwhite = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_2
	this.shape = new cjs.Shape();
	this.shape.graphics.f("#303030").s().p("EhoICksMAAAlJXMDQRAAAMAAAFJXg");

	this.timeline.addTween(cjs.Tween.get(this.shape).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Backgroundwhite, new cjs.Rectangle(-666.5,-1054,1333,2108), null);


(lib.Background = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.instance = new lib.Background_Blue();
	this.instance.setTransform(-667,-1286,1.3655,1.3655);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Background, new cjs.Rectangle(-667,-1286,1334.1,2802), null);


(lib.TimeoutPopup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Image
	this.instance = new lib.TimeUpBird();
	this.instance.setTransform(448.6,-307.5,0.5712,0.571,0,0,180);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// Text
	this.titleTextfield = new cjs.Text("titleTextfield", "50px 'Roboto Medium'", "#333333");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 61;
	this.titleTextfield.lineWidth = 866;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-435.55,-290.6);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// Button
	this.continueButton = new lib.StartGameButton_Overlay();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-6.15,-36.45,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get(this.continueButton).wait(1));

	// PopupBG
	this.instance_1 = new lib.PopupBG_small();
	this.instance_1.setTransform(-561.5,-393.5);

	this.timeline.addTween(cjs.Tween.get(this.instance_1).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.TimeoutPopup, new cjs.Rectangle(-561.5,-393.5,1124,495), null);


(lib.GenericPopup = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text
	this.bodyTextfield = new cjs.Text("bodyTextfield\nLine2", "40px 'Roboto Medium'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 54;
	this.bodyTextfield.lineWidth = 866;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-435.55,-196.3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.titleTextfield = new cjs.Text("titleTextfield", "50px 'Roboto Medium'", "#333333");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 61;
	this.titleTextfield.lineWidth = 866;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-435.55,-290.6);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.titleTextfield},{t:this.bodyTextfield}]}).wait(2));

	// Buttons
	this.cancelButton = new lib.StartGameButton_Overlay();
	this.cancelButton.name = "cancelButton";
	this.cancelButton.setTransform(236.3,246.1,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.continueButton = new lib.StartGameButton_Overlay();
	this.continueButton.name = "continueButton";
	this.continueButton.setTransform(-232.2,246.1,2.7291,2.7272,0,0,0,-0.2,2.7);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.continueButton},{t:this.cancelButton}]}).wait(2));

	// PopupBG
	this.instance = new lib.PopupBG();
	this.instance.setTransform(-561.5,-393.5);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(2));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-561.5,-393.5,1123,787);


(lib.GateKeeperOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// buttons
	this.button2 = new lib.StartGameButton_Overlay();
	this.button2.name = "button2";
	this.button2.setTransform(259.8,540.2,2.7273,2.7273);

	this.button1 = new lib.RevisitTutorialButton();
	this.button1.name = "button1";
	this.button1.setTransform(-238.35,540.2,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.button1},{t:this.button2}]}).wait(1));

	// lines
	this.lines = new lib.GateKeeperOverlayLines();
	this.lines.name = "lines";
	this.lines.setTransform(-34.45,-587);

	this.timeline.addTween(cjs.Tween.get(this.lines).wait(1));

	// Titles
	this.titleTextfield = new cjs.Text("xGatekeeper", "20px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 16;
	this.titleTextfield.lineWidth = 283;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-423.5,-590.8,3,3);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// Text
	this.bodyTextfield = new cjs.Text("• xYou control the red racing car\nline2", "14px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 17;
	this.bodyTextfield.lineWidth = 267;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-423.5,-473.05,3,3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// bg
	this.bg = new lib.TutorialBackgroundTime();
	this.bg.name = "bg";
	this.bg.setTransform(10,6);
	this.bg.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GateKeeperOverlaySkin, new cjs.Rectangle(-819.2,-1202.1,1902.6000000000001,2408), null);


(lib.EndScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// title
	this.bodyTextfield = new cjs.Text("Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here Instructions here ", "40px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 58;
	this.bodyTextfield.lineWidth = 875;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-431.8,-585.752);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// text
	this.titleTextfield = new cjs.Text("Minigame", "108px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 130;
	this.titleTextfield.lineWidth = 867;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-431.8,-789.45);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(1));

	// button
	this.button = new lib.StartGameButton();
	this.button.name = "button";
	this.button.setTransform(0,691.35,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// Background
	this.instance = new lib.StartScreen();
	this.instance.setTransform(-667,-694.15,0.9323,0.9322);

	this.bg = new lib.Background();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bg},{t:this.instance}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.EndScreenSkin, new cjs.Rectangle(-667.5,-1286,1746.9,3256.2), null);


(lib.ProgressDot_1 = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {unselected:0,selected:1};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// timeline functions:
	this.frame_0 = function() {
		this.stop()
	}
	this.frame_16 = function() {
		this.stop()
	}

	// actions tween:
	this.timeline.addTween(cjs.Tween.get(this).call(this.frame_0).wait(16).call(this.frame_16).wait(1));

	// Layer_1
	this.instance = new lib.ProgressDotTween("synched",0);
	this.instance.setTransform(0,0,0.9677,0.9677);

	this.timeline.addTween(cjs.Tween.get(this.instance).to({scaleX:1.3226,scaleY:1.3226},16).wait(1));

	// Layer_4
	this.instance_1 = new lib.Tween2("synched",0);
	this.instance_1.setTransform(0,0,0.6451,0.6451);
	this.instance_1.alpha = 0;

	this.timeline.addTween(cjs.Tween.get(this.instance_1).to({scaleX:1.2903,scaleY:1.2903,alpha:1},16).wait(1));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-20.4,-20.4,41,41);


(lib.Hud = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// texts
	this.timeLabelTextfield = new cjs.Text("xTime", "14px 'Roboto Medium'", "#FFFFFF");
	this.timeLabelTextfield.name = "timeLabelTextfield";
	this.timeLabelTextfield.textAlign = "center";
	this.timeLabelTextfield.lineHeight = 18;
	this.timeLabelTextfield.lineWidth = 97;
	this.timeLabelTextfield.parent = this;
	this.timeLabelTextfield.setTransform(119.8,-22);
ranj.TextOffsetFixer.fix(this.timeLabelTextfield);

	this.timeTextfield = new cjs.Text("00:00", "22px 'Roboto Medium'", "#FFFFFF");
	this.timeTextfield.name = "timeTextfield";
	this.timeTextfield.textAlign = "center";
	this.timeTextfield.lineHeight = 27;
	this.timeTextfield.lineWidth = 95;
	this.timeTextfield.parent = this;
	this.timeTextfield.setTransform(119,-4);
ranj.TextOffsetFixer.fix(this.timeTextfield);

	this.mistakesLabelTextfield = new cjs.Text("xMistakes", "14px 'Roboto Medium'", "#FFFFFF");
	this.mistakesLabelTextfield.name = "mistakesLabelTextfield";
	this.mistakesLabelTextfield.textAlign = "center";
	this.mistakesLabelTextfield.lineHeight = 18;
	this.mistakesLabelTextfield.lineWidth = 97;
	this.mistakesLabelTextfield.parent = this;
	this.mistakesLabelTextfield.setTransform(0.3,-22);
ranj.TextOffsetFixer.fix(this.mistakesLabelTextfield);

	this.mistakesTextfield = new cjs.Text("9999", "22px 'Roboto Medium'", "#FFFFFF");
	this.mistakesTextfield.name = "mistakesTextfield";
	this.mistakesTextfield.textAlign = "center";
	this.mistakesTextfield.lineHeight = 27;
	this.mistakesTextfield.lineWidth = 96;
	this.mistakesTextfield.parent = this;
	this.mistakesTextfield.setTransform(-0.4,-4);
ranj.TextOffsetFixer.fix(this.mistakesTextfield);

	this.scoreLabelTextfield = new cjs.Text("xFound", "14px 'Roboto Medium'", "#FFFFFF");
	this.scoreLabelTextfield.name = "scoreLabelTextfield";
	this.scoreLabelTextfield.textAlign = "center";
	this.scoreLabelTextfield.lineHeight = 18;
	this.scoreLabelTextfield.lineWidth = 97;
	this.scoreLabelTextfield.parent = this;
	this.scoreLabelTextfield.setTransform(-126.3,-22);
ranj.TextOffsetFixer.fix(this.scoreLabelTextfield);

	this.scoreTextfield = new cjs.Text("9999", "22px 'Roboto Medium'", "#FFFFFF");
	this.scoreTextfield.name = "scoreTextfield";
	this.scoreTextfield.textAlign = "center";
	this.scoreTextfield.lineHeight = 27;
	this.scoreTextfield.lineWidth = 97;
	this.scoreTextfield.parent = this;
	this.scoreTextfield.setTransform(-126.05,-4);
ranj.TextOffsetFixer.fix(this.scoreTextfield);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.scoreTextfield},{t:this.scoreLabelTextfield},{t:this.mistakesTextfield},{t:this.mistakesLabelTextfield},{t:this.timeTextfield},{t:this.timeLabelTextfield}]}).wait(1));

	// bg
	this.instance = new lib.TopbarHUD();
	this.instance.setTransform(-255,-31,0.3748,0.3749);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// practice indicator
	this.practiceIndicator = new lib.PracticeIndicatorSkin();
	this.practiceIndicator.name = "practiceIndicator";
	this.practiceIndicator.setTransform(13.9,50.9,0.2999,0.2999);

	this.timeline.addTween(cjs.Tween.get(this.practiceIndicator).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.Hud, new cjs.Rectangle(-255,-31,500,104.7), null);


(lib.FeedbackPopupBG = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.bgRight = new lib.FeedbackPopupBG_Right();
	this.bgRight.name = "bgRight";
	this.bgRight.setTransform(200.5,37.5,1,1,0,0,0,25,37.5);

	this.bgMid = new lib.FeedbackPopupBG_Middle();
	this.bgMid.name = "bgMid";
	this.bgMid.setTransform(113,37.5,1,1,0,0,0,63,37.5);

	this.bgLeft = new lib.FeedbackPopupBG_Left();
	this.bgLeft.name = "bgLeft";
	this.bgLeft.setTransform(25.5,37.5,1,1,0,0,0,25,37.5);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.bgLeft},{t:this.bgMid},{t:this.bgRight}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPopupBG, new cjs.Rectangle(0.5,0,225,75), null);


(lib.PrevButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Previous", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-56.45,-9.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-66.45,15.15,0.3945,0.3945,180);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.NextButton = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {"up":0,"over":1,"down":2,"disabled":3};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Text_Up
	this.upLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.upLabelTextField.name = "upLabelTextField";
	this.upLabelTextField.textAlign = "right";
	this.upLabelTextField.lineHeight = 17;
	this.upLabelTextField.lineWidth = 73;
	this.upLabelTextField.parent = this;
	this.upLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.upLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.upLabelTextField).wait(4));

	// Text_Over
	this.overLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.overLabelTextField.name = "overLabelTextField";
	this.overLabelTextField.textAlign = "right";
	this.overLabelTextField.lineHeight = 17;
	this.overLabelTextField.lineWidth = 73;
	this.overLabelTextField.parent = this;
	this.overLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.overLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.overLabelTextField).wait(4));

	// Text_Down
	this.downLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.downLabelTextField.name = "downLabelTextField";
	this.downLabelTextField.textAlign = "right";
	this.downLabelTextField.lineHeight = 17;
	this.downLabelTextField.lineWidth = 73;
	this.downLabelTextField.parent = this;
	this.downLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.downLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.downLabelTextField).wait(4));

	// Text_Disabled
	this.disabledLabelTextField = new cjs.Text("Next", "14px 'Roboto Medium'", "#FFFFFF");
	this.disabledLabelTextField.name = "disabledLabelTextField";
	this.disabledLabelTextField.textAlign = "right";
	this.disabledLabelTextField.lineHeight = 17;
	this.disabledLabelTextField.lineWidth = 73;
	this.disabledLabelTextField.alpha = 0.49803922;
	this.disabledLabelTextField.parent = this;
	this.disabledLabelTextField.setTransform(-21.6,-9.75);
ranj.TextOffsetFixer.fix(this.disabledLabelTextField);

	this.timeline.addTween(cjs.Tween.get(this.disabledLabelTextField).wait(4));

	// Button
	this.instance = new lib.PrevNextButton();
	this.instance.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_1 = new lib.PrevNextButton_down();
	this.instance_1.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.instance_2 = new lib.PrevNextButton_disabled();
	this.instance_2.setTransform(-15.4,-14.95,0.3945,0.3945);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.instance}]}).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_1}]},1).to({state:[{t:this.instance_2}]},1).wait(1));

	// hitarea
	this.hit = new lib.TutorialButtonHitarea();
	this.hit.name = "hit";
	this.hit.setTransform(-40.75,0.3);
	this.hit.alpha = 0.0117;

	this.timeline.addTween(cjs.Tween.get(this.hit).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-102,-17.9,122.5,36.5);


(lib.BirdPlaceholder = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// circle
	this.instance = new lib.BirdTEMP();
	this.instance.setTransform(-0.95,-1);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.BirdPlaceholder, new cjs.Rectangle(-132.7,-213.8,225.7,213.9), null);


(lib.FeedbackPanel = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// body
	this.bodyTextfield = new cjs.Text("abcdef ", "italic 40px 'Roboto'", "#333333");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.textAlign = "center";
	this.bodyTextfield.lineHeight = 49;
	this.bodyTextfield.lineWidth = 149;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-0.7498,9.8);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(1));

	// Layer_2
	this.bg = new lib.FeedbackPopupBG();
	this.bg.name = "bg";
	this.bg.setTransform(-2,34.25,1,1,0,0,0,112,37.5);

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.FeedbackPanel, new cjs.Rectangle(-113.5,-3.2,225,78.4), null);


(lib.ProgressDots_MC = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// Layer_1
	this.dot6 = new lib.ProgressDot_1();
	this.dot6.name = "dot6";
	this.dot6.setTransform(144,0);

	this.dot0 = new lib.ProgressDot_1();
	this.dot0.name = "dot0";
	this.dot0.setTransform(-144,0);

	this.dot1 = new lib.ProgressDot_1();
	this.dot1.name = "dot1";
	this.dot1.setTransform(-96,0);

	this.dot5 = new lib.ProgressDot_1();
	this.dot5.name = "dot5";
	this.dot5.setTransform(96,0);

	this.dot4 = new lib.ProgressDot_1();
	this.dot4.name = "dot4";
	this.dot4.setTransform(48,0);

	this.dot2 = new lib.ProgressDot_1();
	this.dot2.name = "dot2";
	this.dot2.setTransform(-48,0);

	this.dot3 = new lib.ProgressDot_1();
	this.dot3.name = "dot3";

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.dot3},{t:this.dot2},{t:this.dot4},{t:this.dot5},{t:this.dot1},{t:this.dot0},{t:this.dot6}]}).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.ProgressDots_MC, new cjs.Rectangle(-159,-15,318,30), null);


(lib.HudBottom = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// bird placeholder
	this.bird = new lib.BirdPlaceholder();
	this.bird.name = "bird";
	this.bird.setTransform(-33.1,17.15,0.4197,0.4195,0,0,0,-16.3,-1.1);

	this.timeline.addTween(cjs.Tween.get(this.bird).wait(1));

	// Layer_4
	this.button = new lib.NextLocationButton();
	this.button.name = "button";
	this.button.setTransform(95.85,-1.8,0.8082,0.8065,0,0,0,0.7,-0.6);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(1));

	// text
	this.findLabelTextfield = new cjs.Text("Looking\nfor:", "14px 'Roboto Medium'", "#FFFFFF");
	this.findLabelTextfield.name = "findLabelTextfield";
	this.findLabelTextfield.textAlign = "center";
	this.findLabelTextfield.lineHeight = 17;
	this.findLabelTextfield.lineWidth = 69;
	this.findLabelTextfield.parent = this;
	this.findLabelTextfield.setTransform(-120,-18);
ranj.TextOffsetFixer.fix(this.findLabelTextfield);

	this.timeline.addTween(cjs.Tween.get(this.findLabelTextfield).wait(1));

	// bg
	this.instance = new lib.TopbarHUD();
	this.instance.setTransform(-255,28.6,0.3748,0.3749,0,180,0);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.HudBottom, new cjs.Rectangle(-255,-31,500,59.6), null);


(lib.TutorialOverlaySkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// button start
	this.button = new lib.StartGameButton_Overlay();
	this.button.name = "button";
	this.button.setTransform(311.85,500.2,2.7273,2.7273);

	this.timeline.addTween(cjs.Tween.get(this.button).wait(4));

	// buttons
	this.prevButton = new lib.PrevButton();
	this.prevButton.name = "prevButton";
	this.prevButton.setTransform(-276.5,500.55,3,3,0,0,0,-41,0.1);

	this.nextButton = new lib.NextButton();
	this.nextButton.name = "nextButton";
	this.nextButton.setTransform(236.25,500.55,3,3,0,0,0,-38.7,0.1);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.nextButton},{t:this.prevButton}]}).wait(4));

	// Progress dots
	this.progressDots = new lib.ProgressDots_MC();
	this.progressDots.name = "progressDots";
	this.progressDots.setTransform(-7.65,499.9);

	this.timeline.addTween(cjs.Tween.get(this.progressDots).wait(4));

	// Titles
	this.titleTextfield = new cjs.Text("xTitle", "20px 'Roboto Medium'", "#FFFFFF");
	this.titleTextfield.name = "titleTextfield";
	this.titleTextfield.lineHeight = 16;
	this.titleTextfield.lineWidth = 283;
	this.titleTextfield.parent = this;
	this.titleTextfield.setTransform(-423.5,-453.2,3,3);
ranj.TextOffsetFixer.fix(this.titleTextfield);

	this.timeline.addTween(cjs.Tween.get(this.titleTextfield).wait(4));

	// Text
	this.bodyTextfield = new cjs.Text("• xYou control the red racing car\nline2", "14px 'Roboto'", "#FFFFFF");
	this.bodyTextfield.name = "bodyTextfield";
	this.bodyTextfield.lineHeight = 17;
	this.bodyTextfield.lineWidth = 267;
	this.bodyTextfield.parent = this;
	this.bodyTextfield.setTransform(-423.5,-335.45,3,3);
ranj.TextOffsetFixer.fix(this.bodyTextfield);

	this.timeline.addTween(cjs.Tween.get(this.bodyTextfield).wait(4));

	// Line1
	this.lines1 = new lib.TutorialLines1();
	this.lines1.name = "lines1";
	this.lines1.setTransform(5.4,-366.05,1,1,0,0,0,0,-633.6);

	this.timeline.addTween(cjs.Tween.get(this.lines1).wait(4));

	// Line2
	this.lines2 = new lib.TutorialLines3();
	this.lines2.name = "lines2";
	this.lines2.setTransform(-260.8,-590);

	this.timeline.addTween(cjs.Tween.get(this.lines2).wait(4));

	// Line3
	this.lines3 = new lib.TutorialLines2();
	this.lines3.name = "lines3";
	this.lines3.setTransform(5.2,-366.1,1,1,0,0,0,-0.1,-603.1);

	this.timeline.addTween(cjs.Tween.get(this.lines3).wait(4));

	// Line4
	this.lines4 = new lib.TutorialLines4();
	this.lines4.name = "lines4";
	this.lines4.setTransform(-34.45,-449.4);

	this.timeline.addTween(cjs.Tween.get(this.lines4).wait(4));

	// bg1
	this.bg1 = new lib.TutorialBackgroundBird();
	this.bg1.name = "bg1";
	this.bg1.setTransform(10,20);
	this.bg1.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg1).wait(4));

	// bg2
	this.bg2 = new lib.TutorialBackgroundScore();
	this.bg2.name = "bg2";
	this.bg2.setTransform(10,6);
	this.bg2.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg2).wait(4));

	// bg3
	this.bg3 = new lib.TutorialBackgroundNext();
	this.bg3.name = "bg3";
	this.bg3.setTransform(9.85,6.25);
	this.bg3.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg3).wait(4));

	// bg4
	this.bg4 = new lib.TutorialBackgroundPractice();
	this.bg4.name = "bg4";
	this.bg4.setTransform(-6.1,-0.65,1,1,0,0,0,816,1204);
	this.bg4.alpha = 0.9492;

	this.timeline.addTween(cjs.Tween.get(this.bg4).wait(4));

	this._renderFirstFrame();

}).prototype = p = new cjs.MovieClip();
p.nominalBounds = new cjs.Rectangle(-814.7,-1206.2,1898.1000000000001,2409.7);


(lib.GameScreenSkin = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// hud
	this.hudBottom = new lib.HudBottom();
	this.hudBottom.name = "hudBottom";
	this.hudBottom.setTransform(2.85,786.15,3,3);

	this.hud = new lib.Hud();
	this.hud.name = "hud";
	this.hud.setTransform(2.85,-781.1,3,3);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.hud},{t:this.hudBottom}]}).wait(1));

	// level
	this.level = new lib.LevelPlaceholder();
	this.level.name = "level";
	this.level.setTransform(-540,-698.15);

	this.timeline.addTween(cjs.Tween.get(this.level).wait(1));

	// Background
	this.bg = new lib.Backgroundwhite();
	this.bg.name = "bg";

	this.timeline.addTween(cjs.Tween.get(this.bg).wait(1));

	this._renderFirstFrame();

}).prototype = getMCSymbolPrototype(lib.GameScreenSkin, new cjs.Rectangle(-762.1,-1184.2,1841.5,2239.2), null);


// stage content:
(lib.MainAssets = function(mode,startPosition,loop,reversed) {
if (loop == null) { loop = true; }
if (reversed == null) { reversed = false; }
	var props = new Object();
	props.mode = mode;
	props.startPosition = startPosition;
	props.labels = {};
	props.loop = loop;
	props.reversed = reversed;
	cjs.MovieClip.apply(this,[props]);

	// generic popup
	this.instance = new lib.GenericPopup();
	this.instance.setTransform(-742.05,546.55);

	this.timeline.addTween(cjs.Tween.get(this.instance).wait(1));

	// other elements
	this.instance_1 = new lib.DragNudgeSkin();
	this.instance_1.setTransform(-376.75,2016.3);

	this.popup = new lib.TimeoutPopup();
	this.popup.name = "popup";
	this.popup.setTransform(-742.05,1379.7);

	this.feedbackPanel = new lib.FeedbackPanel();
	this.feedbackPanel.name = "feedbackPanel";
	this.feedbackPanel.setTransform(-736.75,61.25,1,1,0,0,0,-3.5,31.4);

	this.timeline.addTween(cjs.Tween.get({}).to({state:[{t:this.feedbackPanel},{t:this.popup},{t:this.instance_1}]}).wait(1));

	// gatekeeper
	this.instance_2 = new lib.GateKeeperOverlaySkin();
	this.instance_2.setTransform(543.8,870.7,1,1,0,0,0,3.8,-0.3);
	this.instance_2.cache(-821,-1204,1907,2412);

	this.timeline.addTween(cjs.Tween.get(this.instance_2).wait(1));

	// tutorial
	this.instance_3 = new lib.TutorialOverlaySkin();
	this.instance_3.setTransform(543.8,870.7,1,1,0,0,0,3.8,-0.3);
	this.instance_3.cache(-817,-1208,1902,2414);

	this.timeline.addTween(cjs.Tween.get(this.instance_3).wait(1));

	// endscreen
	this.instance_4 = new lib.EndScreenSkin();
	this.instance_4.setTransform(1941.45,871);

	this.timeline.addTween(cjs.Tween.get(this.instance_4).wait(1));

	// gamescreen
	this.instance_5 = new lib.GameScreenSkin();
	this.instance_5.setTransform(540,986,1,1,0,0,0,0,115);

	this.timeline.addTween(cjs.Tween.get(this.instance_5).wait(1));

	this._renderFirstFrame();

}).prototype = p = new lib.AnMovieClip();
p.nominalBounds = new cjs.Rectangle(-763.5,456,3372,2385.2);
// library properties:
lib.properties = {
	id: 'F7DD7F692B0D1D44A7B614DFFAE812BF',
	width: 1080,
	height: 1742,
	fps: 24,
	color: "#666666",
	opacity: 1.00,
	manifest: [
		{src:"assets/skins/images/MainAssets/Background_Blue.png", id:"MainAssets_Background_Blue", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_disabled.png", id:"MainAssets_Button_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_down.png", id:"MainAssets_Button_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/Button_up.png", id:"MainAssets_Button_up", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Left.png", id:"MainAssets_FeedbackPopup_Left", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Middle.png", id:"MainAssets_FeedbackPopup_Middle", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/FeedbackPopup_Right.png", id:"MainAssets_FeedbackPopup_Right", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/MoveNudge.png", id:"MainAssets_MoveNudge", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/OverlayBird01.png", id:"MainAssets_OverlayBird01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/OverlayNext.png", id:"MainAssets_OverlayNext", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/OverlayPracticeIndicator.png", id:"MainAssets_OverlayPracticeIndicator", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/OverlayTime01.png", id:"MainAssets_OverlayTime01", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PopupBG.png", id:"MainAssets_PopupBG", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PopupBG_small.png", id:"MainAssets_PopupBG_small", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PracticeIndicatorBackground.png", id:"MainAssets_PracticeIndicatorBackground", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton.png", id:"MainAssets_PrevNextButton", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_disabled.png", id:"MainAssets_PrevNextButton_disabled", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/PrevNextButton_down.png", id:"MainAssets_PrevNextButton_down", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot.png", id:"MainAssets_ProgressDot", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/ProgressDot_Selected.png", id:"MainAssets_ProgressDot_Selected", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/StartScreen.png", id:"MainAssets_StartScreen", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TimeUpBird.png", id:"MainAssets_TimeUpBird", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TopbarHUD.png", id:"MainAssets_TopbarHUD", bundle:"MainAssets"},
		{src:"assets/skins/images/MainAssets/TutorialBackgroundNext_1.png", id:"MainAssets_TutorialBackgroundNext_1", bundle:"MainAssets"}
	],
	preloads: []
};



})(lib.MainAssets = {}, images, ss, createjs);
module.exports = lib.MainAssets;